import axios from 'axios';
import { ROLE_GUEST } from '@spa/shared/constants/roleTypes';

const X_UNIPLACES_GROUPS = 'Default,rich';

const client = axios.create({
  baseURL: `${process.env.CORE_URL}/api`,
  headers: {
    'X-Uniplaces-token': process.env.CORE_UNIPLACES_TOKEN,
    'X-Context-role': ROLE_GUEST,
    'X-Uniplaces-groups': X_UNIPLACES_GROUPS
  }
});

export default client;
